import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { loginForm } from "../../loginFormSetup.js";
import { useTexts } from "./useTexts.js";
function PasswordField(props) {
  const { autoFocusField, componentProps, fieldProps } = props;
  const texts = useTexts();
  const autoFocus = autoFocusField === "password";
  const requiredValidationOptions = useMemo(() => ({ message: texts.required, priority: 10 }), [texts.required]);
  return /* @__PURE__ */ jsx(
    loginForm.Password,
    {
      debounce: -1,
      ...fieldProps,
      name: "password",
      testId: "login-password",
      label: texts.label,
      helperText: texts.info,
      validateOn: "blur",
      placeholder: texts.placeholder,
      textfieldProps: {
        autoFocus,
        autoComplete: "password",
        ...componentProps,
        ...fieldProps?.textfieldProps
      },
      required: true,
      requiredValidationOptions
    }
  );
}
export {
  PasswordField
};
//# sourceMappingURL=PasswordField.js.map
